// extracted by mini-css-extract-plugin
export var title = "NewsletterSubscription-module--title--djCJC";
export var box = "NewsletterSubscription-module--box--Zcxhm";
export var terms = "NewsletterSubscription-module--terms--7Y0WK";